import { store } from '~/stores';
import { actions } from '~/stores/ducks';

const CustomerService = {
  setCustomer: customer => store.dispatch(actions.setCustomer(customer)),
  getCustomer: () => store.getState().customer,
};

export default CustomerService;
